"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.componentsCrm_en_us = void 0;
function componentsCrm_en_us() {
    return {
        "components.crm.contacts.detail.title": "Contact Details",
        "components.crm.contacts.avatar": "Avatar",
        "components.crm.contacts.firstname": "First Name",
        "components.crm.contacts.lastname": "Last Name",
        "components.crm.contacts.email": "Email",
        "components.crm.contacts.phone": "Phone",
        "components.crm.contacts.mobile": "Mobile",
        "components.crm.contacts.birthday": "Birthday",
        "components.crm.contacts.address": "Private Address",
        "components.crm.contacts.company": "Company Name",
        "components.crm.contacts.companyposition": "Position",
        "components.crm.contacts.companyphone": "Company Phone",
        "components.crm.contacts.companyaddress": "Company Address",
        "components.crm.contacts.deletion.title": "Delete contact",
        "components.crm.contacts.deletion.message": "Do you really want to delete this contact?"
    };
}
exports.componentsCrm_en_us = componentsCrm_en_us;
